/**
 * IdleWarningModal — shown by SessionGuard ~60s before an inactivity logout.
 *
 * "Stay signed in" resets the idle clock + renews the token; "Log out" ends the
 * session now. Rendered above all app chrome; the backdrop is non-dismissable
 * (only the two explicit actions resolve it) so it can't be clicked away by
 * accident and then silently expire.
 */
import React from 'react';
import { ShieldAlert } from 'lucide-react';
import './idle-warning.css';

export default function IdleWarningModal({ secondsLeft = 60, onStay, onLogout }) {
    return (
        <div className="v3-idle-backdrop" role="alertdialog" aria-modal="true" aria-labelledby="v3-idle-title">
            <div className="v3-idle-card">
                <div className="v3-idle-icon"><ShieldAlert size={22} /></div>
                <h3 id="v3-idle-title" className="v3-idle-title">Still there?</h3>
                <p className="v3-idle-body">
                    You&apos;ve been inactive for a while. For your security you&apos;ll be signed
                    out in <strong className="v3-idle-count">{secondsLeft}s</strong>.
                </p>
                <div className="v3-idle-actions">
                    <button type="button" className="v3-idle-btn ghost" onClick={onLogout}>
                        Log out
                    </button>
                    <button type="button" className="v3-idle-btn primary" onClick={onStay} autoFocus>
                        Stay signed in
                    </button>
                </div>
            </div>
        </div>
    );
}
